import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://laclive.de";
const DEFAULT_IMAGE = `${SITE}/og-image.jpg`;
const DEFAULT_DESC = "LacLive - naturally tolerant. Mit Lactoseintoleranz normal leben und die Toleranz in 12 Wochen wieder aufbauen. Wissenschaftlich fundiert, alltagstauglich.";

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "LacLive",
  alternateName: "LacLive - naturally tolerant",
  url: SITE,
  logo: `${SITE}/laclive-logo.png`,
  email: "laclive@gmx.de",
  founder: {
    "@type": "Person",
    name: "Prof. Dr. med. Hagen Schmal",
    honorificPrefix: "Prof. Dr. med.",
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Maxim-Gorkij-Str. 9",
    postalCode: "79111",
    addressLocality: "Freiburg",
    addressCountry: "DE",
  },
  vatID: "DE298551357",
};

export default function Seo({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  jsonLd,
  keywords,
  robots = "index, follow",
}) {
  const fullTitle = title ? `${title} · LacLive` : "LacLive - Mit Lactoseintoleranz normal leben";
  const desc = description || DEFAULT_DESC;
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={robots} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="LacLive" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="de_DE" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
      <script type="application/ld+json">
        {JSON.stringify(orgJsonLd)}
      </script>
    </Helmet>
  );
}

export function articleJsonLd(article, url) {
  return {
    "@context": "https://schema.org",
    "@type": "MedicalWebPage",
    headline: article.title,
    description: article.excerpt,
    datePublished: article.date,
    author: {
      "@type": "Person",
      name: "Prof. Dr. med. Hagen Schmal",
    },
    publisher: {
      "@type": "Organization",
      name: "LacLive",
      logo: { "@type": "ImageObject", url: `${SITE}/laclive-logo.png` },
    },
    image: article.image?.startsWith("http") ? article.image : `${SITE}${article.image || "/og-image.jpg"}`,
    mainEntityOfPage: url,
    about: { "@type": "MedicalCondition", name: "Lactoseintoleranz" },
    inLanguage: "de-DE",
  };
}
